import { ElementRef, EventEmitter, QueryList } from '@angular/core';
import { PdfExportService } from '../../../services/export-pdf/pdf-export.service';
import { InfluencerOverviewPostContentComponent } from '../post-list/influencer-overview-post-content/influencer-overview-post-content.component';
import { UserService } from '../../../services/user.service';
var CssEnum;
(function (CssEnum) {
    CssEnum["HIDDEN"] = "hidden";
    CssEnum["VISIBLE"] = "visible";
    CssEnum["MAX_CONTENT"] = "max-content";
})(CssEnum || (CssEnum = {}));
var ShowMore;
(function (ShowMore) {
    ShowMore[ShowMore["MIN_POST"] = 10] = "MIN_POST";
})(ShowMore || (ShowMore = {}));
var PostListMansonryComponent = /** @class */ (function () {
    function PostListMansonryComponent(pdfService, userService) {
        this.pdfService = pdfService;
        this.userService = userService;
        this.displayMode = 'desktop';
        this.selectToPreviewPost = new EventEmitter();
        this.openIncompleteStory = new EventEmitter();
        this.keepOrder = false;
        this.isLayoutCompleted = new EventEmitter();
        this.activePost = null;
    }
    PostListMansonryComponent.prototype.ngOnInit = function () {
        if (this.postList && this.postList.length > ShowMore.MIN_POST) {
            this.height = this.showMoreheight;
            this.overflow = CssEnum.HIDDEN;
        }
        else {
            this.height = CssEnum.MAX_CONTENT;
            this.overflow = CssEnum.VISIBLE;
        }
        this.currentInfluencer = this.userService.getInfluencerInfo();
    };
    // Get ng masonry grid instance first
    PostListMansonryComponent.prototype.onNgMasonryInit = function ($event) {
        this._masonry = $event;
    };
    PostListMansonryComponent.prototype.layoutComplete = function (laidOutItems) {
        if (this._masonry) {
            if (laidOutItems && this._masonry.items.length === this.postList.length) {
                this.pdfService.incrementNumberReportReady(PostListMansonryComponent.COMPONENT_NAME);
            }
            if (Array.isArray(laidOutItems) && laidOutItems.length === this.postList.length) {
                this.isLayoutCompleted.emit(true);
            }
        }
    };
    PostListMansonryComponent.prototype.showMore = function () {
        this.height = CssEnum.MAX_CONTENT;
        this.overflow = CssEnum.VISIBLE;
    };
    PostListMansonryComponent.prototype.prependItems = function (newItems) {
        if (this._masonry) {
            // set status to 'prepend' before adding items to NgMasonryGrid otherwise default: 'append' will applied
            this._masonry.setAddStatus('prepend');
            (_a = this.postList).splice.apply(_a, [0, 0].concat(newItems));
        }
        var _a;
    };
    PostListMansonryComponent.prototype.onSelectedPost = function (influencer) {
        this.selectToPreviewPost.emit(influencer);
    };
    PostListMansonryComponent.prototype.addToPreviewed = function (item) {
        this.selectToPreviewPost.emit(item);
    };
    PostListMansonryComponent.prototype.hidePopupCardHover = function (evt) {
        var clickingOnImage = evt && evt.target && evt.target.classList.length > 0 && evt.target.classList.contains('post-img');
        if (this.popup && !this.keepHoverPopup && !clickingOnImage) {
            this.popup.nativeElement.style.display = 'none';
        }
    };
    PostListMansonryComponent.COMPONENT_NAME = 'PostListMansonryComponent';
    return PostListMansonryComponent;
}());
export { PostListMansonryComponent };



// WEBPACK FOOTER //
// ./src/app/main/influencer/post-list-mansonry/post-list-mansonry.component.ts.pre-build-optimizer.js